module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-nav-wrapper"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('comb.todo')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('word.total')) + " " + _vm._s(_vm.totalCount) + " " + _vm._s(_vm.$t('word.item')))])]), _vm._v(" "), _c('div', {
    staticClass: "tabs-wrapper"
  }, [_c('button', {
    class: {
      'active': _vm.statusCode === 0
    },
    on: {
      "click": function($event) {
        _vm.getTodoList(0, 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.all')))]), (_vm.$parent.todos['0'] > 0) ? _c('i', {
    staticClass: "red-dot"
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    class: {
      'active': _vm.statusCode === 1
    },
    on: {
      "click": function($event) {
        _vm.getTodoList(1, 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.invitationProcess')))]), (_vm.$parent.todos['1'] > 0) ? _c('i', {
    staticClass: "red-dot"
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    class: {
      'active': _vm.statusCode === 2
    },
    on: {
      "click": function($event) {
        _vm.getTodoList(2, 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.auditFailure')))]), (_vm.$parent.todos['2'] > 0) ? _c('i', {
    staticClass: "red-dot"
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    class: {
      'active': _vm.statusCode === 3
    },
    on: {
      "click": function($event) {
        _vm.getTodoList(3, 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.taskUpdate')))]), (_vm.$parent.todos['3'] > 0) ? _c('i', {
    staticClass: "red-dot"
  }) : _vm._e()])])]), _vm._v(" "), (_vm.totalCount === 0 && _vm.statusCode === 0) ? _c('div', {
    staticClass: "copyright-empty-task-list"
  }, [_c('p', {
    staticClass: "no-task"
  }, [_vm._v("您可以通过"), _c('a', {
    attrs: {
      "href": ((_vm.$store.state.A_PC_HOST) + "/requirementview")
    }
  }, [_vm._v("参加海选")]), _vm._v("或"), _c('router-link', {
    attrs: {
      "to": {
        name: 'anchorMyVoiceTag'
      }
    }
  }, [_vm._v("添加声音标签")]), _vm._v("获得更多播讲机会")], 1)]) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.pageLoading),
      expression: "pageLoading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "copyright-tasks-list-wrapper"
  }, _vm._l((_vm.todoList), function(item, index) {
    return _c('div', {
      staticClass: "task-item"
    }, [_c('div', {
      staticClass: "title"
    }, [(_vm.statusCode === 1) ? _c('span', {
      staticClass: "status"
    }, [_vm._v(_vm._s(item.recruitmentOption === 1 ? '指定任务邀约' : item.recruitmentOption === 2 ? '海选任务邀约' : '限时任务邀约'))]) : _c('span', {
      staticClass: "status"
    }, [_vm._v(_vm._s(item.requirementViewStatusLabel))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDate(item.requirementCreateTime)))])]), _vm._v(" "), _c('div', {
      staticClass: "task-content-wrapper"
    }, [(item.requirementLogoPic) ? _c('img', {
      ref: "img",
      refInFor: true,
      staticClass: "task-cover",
      attrs: {
        "src": _vm.$store.state.UPLOAD_IMG_HOST + item.requirementLogoPic
      },
      on: {
        "error": function($event) {
          _vm.setDefaultBookCoverImg(index)
        }
      }
    }) : _c('img', {
      staticClass: "task-cover",
      attrs: {
        "src": _vm.$store.state.IMG_HOST + 'bookCoverDefault.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "task-content",
      class: {
        'task-content-single': item.requirementId
      }
    }, [_c('div', {
      staticClass: "content"
    }, [_c('span', {
      staticClass: "task-name"
    }, [_vm._v(_vm._s(item.requirementTitle))]), _vm._v(" "), (item.typeId === 1 && (item.recruitmentOption === 1 || item.recruitmentOption === 2)) ? _c('div', [_c('span', {
      staticClass: "task-anchor"
    }, [_vm._v("恭喜，收到任务邀约！请尽快处理。剩余时间："), _c('strong', {
      staticStyle: {
        "color": "#fc5832"
      }
    }, [_vm._v(_vm._s(item.context))])])]) : _vm._e(), _vm._v(" "), (item.typeId === 1 && item.recruitmentOption === 4) ? _c('div', [_c('span', {
      staticClass: "task-anchor"
    }, [_vm._v("恭喜，收到任务邀约！请尽快处理，否则任务可能被其他主播抢走哦！剩余时间："), _c('strong', {
      staticStyle: {
        "color": "#fc5832"
      }
    }, [_vm._v(_vm._s(item.context))])])]) : _vm._e(), _vm._v(" "), (item.typeId === 2) ? _c('div', [_c('span', {
      staticClass: "task-anchor"
    }, [_vm._v("有"), _c('strong', {
      staticStyle: {
        "color": "#fc5832"
      }
    }, [_vm._v(_vm._s(item.context))]), _vm._v("条声音审核不合格")])]) : _vm._e(), _vm._v(" "), (item.typeId === 3) ? _c('div', [_c('span', {
      staticClass: "task-anchor"
    }, [_vm._v("有"), _c('strong', {
      staticStyle: {
        "color": "#fc5832"
      }
    }, [_vm._v(_vm._s(item.context))]), _vm._v("条任务更新")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "buttons"
    }, [(item.typeId === 1) ? _c('a', {
      staticClass: "check-task",
      attrs: {
        "href": ((_vm.$store.state.A_PC_HOST) + "/requirement/" + (item.requirementId) + "/candidate"),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.$t('comb.toHandle')))]) : _vm._e(), _vm._v(" "), (item.typeId === 2) ? _c('a', {
      staticClass: "check-task",
      attrs: {
        "href": ((_vm.$store.state.A_PC_HOST) + "/workbench/task/" + (item.taskId) + "/work"),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.$t('comb.toHandle')))]) : _vm._e(), _vm._v(" "), (item.typeId === 3) ? _c('a', {
      staticClass: "check-task",
      attrs: {
        "href": ((_vm.$store.state.A_PC_HOST) + "/workbench/task/" + (item.taskId) + "/material"),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.$t('word.check')))]) : _vm._e()])])])])
  })), _vm._v(" "), (_vm.totalPage >= 2) ? _c('div', {
    staticClass: "center-tasks-pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-count": _vm.totalPage,
      "layout": "prev, pager, next"
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a8820f0!./~/vue-loader/lib/selector.js?type=template&index=0!./views/anchor/center/Todo.vue
// module id = 542
// module chunks = 0